import { CASA_30_DEVOTIONALS, CASA_30_TRAIL } from "./CasaTrail.generated";

export const TRAILS_DATA = [
  {
    id: "plataforma",
    title: "DEUS COMO PLATAFORMA",
    subtitle: "Fundamentos para voltar ao concreto",
    duration: 5,
    color: "#D6A85C",
    icon: "Home",
    isProgressive: true,
    description: "Uma trilha sobre fé, Evangelho, memória e fundamento: Deus não como uma opção religiosa, mas como o lugar onde a vida inteira é construída.",
    progress: 0,
    nextDay: "Começar"
  },
  {
    id: "vida-interior",
    title: "VIDA INTERIOR",
    subtitle: "Direção, descanso e maturidade",
    duration: 5,
    color: "#E2B86B",
    icon: "MapPin",
    isProgressive: true,
    description: "Um caminho para olhar para dentro sem perder Deus de vista: direção, rendição, tempestades, fraqueza e perseverança.",
    progress: 0,
    nextDay: "Começar"
  },
  {
    id: "igreja-mesa",
    title: "IGREJA COMO MESA",
    subtitle: "Comunhão, entrega e corpo",
    duration: 5,
    color: "#64C7D0",
    icon: "Coffee",
    isProgressive: true,
    description: "Uma trilha sobre a Igreja como corpo de Cristo, mesa compartilhada e entrega concreta em favor da formação do outro.",
    progress: 0,
    nextDay: "Começar"
  },
  {
    id: "proposito",
    title: "PROPÓSITO RELACIONAL",
    subtitle: "Fé que vira serviço",
    duration: 5,
    color: "#2AC37A",
    icon: "Tree",
    isProgressive: true,
    description: "Devocionais sobre dons, trabalho, missão e propósito: a fé não existe para acumular bênçãos, mas para nos tornar bênção.",
    progress: 0,
    nextDay: "Começar"
  },
  {
    id: "reino-publico",
    title: "REINO NO MUNDO REAL",
    subtitle: "Teologia pública e presença",
    duration: 5,
    color: "#8B7CFF",
    icon: "Globe",
    isProgressive: true,
    description: "Um caminho para pensar cultura, cidade, política, trabalho e testemunho a partir do Reino, sem separar domingo e segunda-feira.",
    progress: 0,
    nextDay: "Começar"
  },
  {
    id: "casa-relacoes",
    title: "CASA E RELAÇÕES",
    subtitle: "Família, aliança e maturidade",
    duration: 5,
    color: "#F43F5E",
    icon: "Heart",
    isProgressive: true,
    description: "Uma trilha para tratar família, casamento, sexualidade e vínculos como lugar de formação, não como vitrine de perfeição.",
    progress: 0,
    nextDay: "Começar"
  }
];

const day = ({
  day: dayNumber,
  title,
  verse,
  verseText,
  sourceFile,
  macroTheme,
  objective,
  devotional,
  question,
  practice,
  reflectionPrompt
}) => ({
  day: dayNumber,
  title,
  verse,
  verseText,
  sourceFile,
  macroTheme,
  objective,
  devotional,
  question,
  practice,
  reflectionPrompt,
  done: false
});

export const DEVOTIONALS_MOCK = {
  plataforma: [
    day({
      day: 1,
      title: "DEUS NÃO É UMA OPÇÃO",
      verse: "Colossenses 3:13",
      verseText: "Suportem-se uns aos outros.",
      sourceFile: "devocionais/Devocional_02-09.txt",
      macroTheme: "Deus como fundamento",
      devotional: "Uma das maiores tragédias da humanidade é começar a ver Deus como uma opção entre muitas. Quando Deus vira alternativa, a vida inteira passa a ser medida por preferências, conveniências e necessidades momentâneas.\n\nMas Deus não é uma alternativa. Ele é a plataforma onde tudo está construído. O pecado é esse salto para fora de Deus, na esperança de encontrar vida em algum lugar onde a vida não pode ser sustentada.\n\nQuando enxergamos Deus como fundamento, até a palavra comunhão muda de sentido. Suportar o outro não é apenas tolerar, incentivar ou torcer. Suportar é oferecer condições para que a vida do outro seja formada pela minha entrega.\n\nUma árvore suporta o fruto. Uma mãe suporta a criança. A fé cristã nos chama a viver assim: não apenas recebendo de Deus, mas nos tornando lugar onde a vida de alguém pode ser gerada.",
      question: "Em qual área você tem tratado Deus como uma opção que pode ser usada, e não como fundamento que precisa ordenar tudo?",
      practice: "Hoje, escolha uma relação concreta e pergunte: o que Deus depositou em mim que precisa servir à formação dessa pessoa?",
      reflectionPrompt: "Escreva sobre uma área em que sua vida precisa voltar a ser construída em Deus."
    }),
    day({
      day: 2,
      title: "O EVANGELHO É UM FATO",
      verse: "Lucas 22:19",
      verseText: "Façam isto em memória de mim.",
      sourceFile: "devocionais/05-04.txt",
      macroTheme: "memória e Evangelho",
      devotional: "Quando Jesus diz para fazer em memória dele, Ele não está chamando os discípulos para uma expectativa vaga. Memória só existe porque algo aconteceu. O Evangelho não é uma ilusão espiritual, uma especulação ou um desejo religioso. O Evangelho aconteceu.\n\nA fé cristã se sustenta sobre fatos: Deus abriu caminho, libertou, sustentou, encarnou, morreu e ressuscitou. Por isso a ceia aponta para uma memória viva. Não lembramos do que gostaríamos que Deus fizesse. Lembramos do que Ele já fez.\n\nEssa memória corrige nossa ansiedade. Muitas vezes a tristeza nasce porque criamos um roteiro e esperamos que Jesus obedeça. Mas a fé não é pedir que Deus confirme nossas expectativas. Fé é ser reconduzido ao que Cristo já realizou.",
      question: "Você tem alimentado sua fé com memória do que Cristo fez ou com ansiedade pelo que ainda quer que Ele faça?",
      practice: "Antes de pedir algo hoje, escreva três fatos da graça de Deus na sua história e ore a partir deles.",
      reflectionPrompt: "Que memória do Evangelho precisa voltar a sustentar sua fé nesta fase?"
    }),
    day({
      day: 3,
      title: "GRAÇA NÃO É MÁGICA",
      verse: "2 Coríntios 13:14",
      verseText: "A graça do Senhor Jesus Cristo, o amor de Deus e a comunhão do Espírito Santo sejam com todos vocês.",
      sourceFile: "devocionais/09-05.txt",
      macroTheme: "graça que educa",
      devotional: "A graça de Deus não nos salva de maneira mágica. Ela não faz por nós aquilo que não queremos fazer diante de Deus. A graça não fará apenas por você; a graça fará de você alguém novo.\n\nO Evangelho não é uma receita para limpar comportamento. Ele é revelação de uma nova forma de ver a vida. Quando o caminho é tratado como estrada, procuramos passos, regras e atalhos. Mas Jesus disse que o caminho é uma pessoa.\n\nSe o caminho é uma pessoa, caminhar com Deus é conhecer Cristo. E conhecer Cristo transforma a maneira como educamos, trabalhamos, servimos, criamos filhos, lidamos com valores e oferecemos vida ao mundo.",
      question: "Você está buscando uma receita de comportamento ou uma relação real com Cristo?",
      practice: "Escolha um comportamento que você tenta corrigir há muito tempo e pergunte qual visão de vida precisa ser transformada antes dele.",
      reflectionPrompt: "Onde a graça precisa deixar de ser teoria e começar a educar sua forma de viver?"
    }),
    day({
      day: 4,
      title: "A VERDADE LIBERTA",
      verse: "João 8:32",
      verseText: "Conhecerão a verdade, e a verdade os libertará.",
      sourceFile: "devocionais/23-03.txt",
      macroTheme: "verdade contra ilusão",
      devotional: "Nós vivemos cercados por mentiras: sobre Deus, sobre nós, sobre sucesso, sobre felicidade e sobre liberdade. A mentira moderna muda de roupa, mas continua fazendo a mesma proposta antiga: viver fora da verdade e ainda esperar plenitude.\n\nJesus não disse que opinião liberta, nem que informação liberta. Ele disse que a verdade liberta. A verdade não é apenas algo que eu uso para vencer discussões. A verdade é uma pessoa que reorganiza meu interior.\n\nQuando a verdade de Cristo entra, ela desmonta as narrativas que eu usei para justificar medo, orgulho, controle e religiosidade. Ela liberta porque devolve a vida ao seu fundamento.",
      question: "Qual mentira tem organizado suas decisões como se fosse verdade?",
      practice: "Nomeie uma mentira que você tem repetido sobre si mesmo e responda a ela com uma verdade do Evangelho.",
      reflectionPrompt: "Que narrativa precisa ser confrontada pela verdade de Cristo hoje?"
    }),
    day({
      day: 5,
      title: "CONSTRUIR SOBRE A ROCHA",
      verse: "Mateus 7:24-27",
      verseText: "Quem ouve estas minhas palavras e as pratica é como um homem prudente que construiu a sua casa sobre a rocha.",
      sourceFile: "devocionais/21-04.txt",
      macroTheme: "fundamento e prática",
      devotional: "Sábios e tolos constroem casas. A diferença não está apenas no resultado aparente, mas no fundamento lançado. A areia costuma ser mais rápida, barata e eficiente aos olhos de quem só quer ver a casa pronta.\n\nJesus nos ensina que bons resultados não são privilégio dos sábios. O tolo também produz coisas impressionantes. Mas a tempestade revela o fundamento que estava escondido.\n\nUma fé sem raiz pode parecer funcional por algum tempo. Ela entrega comportamento, resultado e aparência. Mas só a palavra de Cristo ouvida e praticada forma uma vida que permanece quando o vento muda.",
      question: "Existe algo que está dando resultado na sua vida, mas foi construído sobre motivos errados?",
      practice: "Revise uma decisão importante e pergunte: isso nasce da obediência ou apenas da pressa por resultado?",
      reflectionPrompt: "Onde Deus está chamando você a trocar velocidade por fundamento?"
    })
  ],

  "vida-interior": [
    day({
      day: 1,
      title: "PARA QUEM IREMOS?",
      verse: "João 6:66-68",
      verseText: "Senhor, para quem iremos? Tu tens as palavras de vida eterna.",
      sourceFile: "devocionais/Devocional_22-09.txt",
      macroTheme: "direção espiritual",
      devotional: "Existem fases em que a vida parece oferecer muitas opções e nenhuma direção. A gente pode escolher uma carreira, uma cidade, uma relação, um plano, uma igreja, uma rotina inteira. Mesmo assim, por dentro, permanece a pergunta: para onde tudo isso está me levando?\n\nEm João 6, muitos discípulos deixam Jesus. A caminhada ficou exigente demais, e aqueles que antes o seguiam agora voltam atrás. Jesus olha para os doze e pergunta se eles também querem ir embora.\n\nPedro responde como alguém que encontrou mais do que uma alternativa religiosa: Senhor, para quem iremos? Tu tens as palavras de vida eterna. O mundo oferece opções. Deus oferece direção.",
      question: "O caminho que você está seguindo hoje está te levando para onde Deus te enviou, ou apenas para onde você desejou chegar?",
      practice: "Escolha uma decisão atual e ore perguntando se ela te aproxima da vontade de Deus ou apenas protege o seu controle.",
      reflectionPrompt: "Escreva sobre uma área em que você tem tratado Jesus como uma opção, não como direção."
    }),
    day({
      day: 2,
      title: "A VIDA QUE EU SEMPRE QUIS",
      verse: "Tiago 4:13-17",
      verseText: "Vocês são como a neblina que aparece por um pouco de tempo e depois se dissipa.",
      sourceFile: "devocionais/Devocional_24-09.txt",
      macroTheme: "rendição e controle",
      devotional: "A vida é feita de situações que não conseguimos dominar. Mesmo assim, quase tudo ao nosso redor ensina que precisamos conquistar a vida que sempre quisemos.\n\nTiago confronta essa forma de viver: planejar como se a vida pertencesse a nós. O problema não é ter planos. O problema é transformar Deus em uma garantia espiritual para os planos que não queremos entregar.\n\nConfiar em Deus não é perder responsabilidade. É abandonar a ilusão de que sua vida só será boa se sair exatamente como você imaginou.",
      question: "Em que área você tem tentado usar Deus para confirmar seus planos, em vez de se render à vontade dele?",
      practice: "Releia seus planos desta semana e escreva: se o Senhor quiser. Depois ore entregando o resultado.",
      reflectionPrompt: "Quais sinais mostram que você está tentando controlar uma área que Deus está chamando você a entregar?"
    }),
    day({
      day: 3,
      title: "TEMPESTADES DENTRO DE MIM",
      verse: "Marcos 4:35-41",
      verseText: "Levantou-se um forte vendaval, e as ondas se lançavam sobre o barco.",
      sourceFile: "devocionais/03-06.txt",
      macroTheme: "ansiedade e paz",
      devotional: "Nem toda tempestade que nos derruba está do lado de fora. Existem ventos que ninguém vê e medos que continuam ativos mesmo quando tudo parece normal.\n\nNo barco, os discípulos estavam tomados pelo desespero, enquanto Jesus dormia. O vento estava fora dele, não dentro dele. Isso revela que paz não é ausência de crise, mas presença de Deus no centro da vida.\n\nO Evangelho não existe apenas para resolver coisas para nós. Ele existe para nos resolver em Deus.",
      question: "Qual tempestade interna você tem tentado enfrentar sozinho, como se admitir medo fosse sinal de falta de fé?",
      practice: "Ore sem performance. Diga a Deus onde você está cansado, com medo ou confuso.",
      reflectionPrompt: "Descreva a tempestade que está acontecendo dentro de você e o que muda quando Jesus está no barco."
    }),
    day({
      day: 4,
      title: "A GRAÇA NA FRAQUEZA",
      verse: "2 Coríntios 12:9",
      verseText: "A minha graça te basta, porque o meu poder se aperfeiçoa na fraqueza.",
      sourceFile: "devocionais/12-08.txt",
      macroTheme: "fraqueza e entendimento",
      devotional: "Nós costumamos acreditar que sofremos porque nos falta força. Mas há sofrimentos que não se resolvem com mais força. Eles pedem entendimento.\n\nPaulo pediu que Deus removesse seu espinho. A resposta não foi uma explicação completa, mas uma revelação suficiente: a graça basta.\n\nNo Reino, maturidade não é parecer inabalável. É permanecer em Deus mesmo quando as forças acabam. A força pode falhar. O entendimento de Deus permanece.",
      question: "Em qual fraqueza você tem pedido apenas alívio, quando talvez Deus também queira produzir entendimento?",
      practice: "Nomeie uma fraqueza diante de Deus sem tentar justificá-la.",
      reflectionPrompt: "O que sua fraqueza tem revelado sobre sua dependência de Deus?"
    }),
    day({
      day: 5,
      title: "PROVADO E APROVADO",
      verse: "Tiago 1:1-4",
      verseText: "A prova da sua fé produz perseverança.",
      sourceFile: "devocionais/18-08 (provações).txt",
      macroTheme: "provação e maturidade",
      devotional: "Quando passamos por provações, uma pergunta costuma aparecer: se Deus me ama, por que estou sofrendo? Tiago escreve para irmãos que conheciam Deus e ainda assim enfrentavam perdas, injustiças e incertezas.\n\nEle não pede que o cristão celebre a dor como se sofrimento fosse bom. Ele ensina que, em Deus, a provação não tem a palavra final.\n\nAs provações são certas, variadas e passageiras. Nas mãos de Deus, produzem perseverança, maturidade e integridade.",
      question: "Qual provação você tem interpretado como abandono, quando talvez Deus esteja usando esse processo para formar maturidade?",
      practice: "Escreva duas listas: o que essa dificuldade tem tirado de você e o que Deus pode estar formando em você.",
      reflectionPrompt: "Onde você precisa trocar a pergunta 'quando isso acaba?' por 'o que está sendo formado em mim?'"
    })
  ],

  "igreja-mesa": [
    day({
      day: 1,
      title: "AINDA ACREDITO NA IGREJA",
      verse: "Efésios 1:22-23",
      verseText: "A igreja, que é o seu corpo, a plenitude daquele que enche todas as coisas.",
      sourceFile: "devocionais/devocional_23-07.txt",
      macroTheme: "identidade da Igreja",
      devotional: "A glória da Igreja não está na sua capacidade, está na sua identidade. A Igreja não é uma expectativa frágil que depende da nossa criatividade. Ela é o corpo de Cristo.\n\nNão estamos dando forma para a Igreja. Estamos sendo transformados naquilo que ela é desde a eternidade. Isso muda nossa postura diante da cidade e das crises.\n\nUma igreja madura não vive ocupada com as próprias carências. Ela se entrega por amor para ser luz na vida das pessoas.",
      question: "Você tem olhado para a Igreja a partir das carências humanas ou da identidade que Cristo deu a ela?",
      practice: "Ore pela sua igreja local agradecendo por aquilo que ela é em Cristo antes de pedir que ela resolva algo para você.",
      reflectionPrompt: "Como sua visão da Igreja precisa ser corrigida pelo Evangelho?"
    }),
    day({
      day: 2,
      title: "SUPORTAR É GERAR VIDA",
      verse: "Colossenses 3:13",
      verseText: "Suportem-se uns aos outros.",
      sourceFile: "devocionais/Devocional_02-09.txt",
      macroTheme: "formação do outro",
      devotional: "Suportar uns aos outros não é apenas aguentar pessoas difíceis. Suportar é transmitir virtude. É entregar aquilo que foi depositado em mim para formar vida no outro.\n\nA bênção está em formar o seguinte. Uma árvore suporta o fruto. Uma mãe suporta a criança. A Igreja suporta pessoas em formação.\n\nEsse tipo de comunhão custa. Mas Jesus não viveu muito; Jesus viveu tudo. A vida cristã não é preservação de si, mas entrega em amor.",
      question: "Quem Deus colocou perto de você para ser formado pela sua entrega, não apenas tolerado pela sua paciência?",
      practice: "Faça hoje uma ação silenciosa que ajude alguém a permanecer de pé.",
      reflectionPrompt: "O que você precisa deixar de proteger em si mesmo para suportar melhor alguém?"
    }),
    day({
      day: 3,
      title: "O AMOR E A GRAÇA NA COMUNHÃO",
      verse: "2 Coríntios 13:14",
      verseText: "A graça do Senhor Jesus Cristo, o amor de Deus e a comunhão do Espírito Santo sejam com todos vocês.",
      sourceFile: "devocionais/09-05.txt",
      macroTheme: "comunhão do Espírito",
      devotional: "O amor do Pai e a graça do Filho se revelam na comunhão do Espírito. Sem comunhão, a graça vira ideia e o amor vira discurso.\n\nA comunhão não é apenas estar no mesmo ambiente. É permitir que o Espírito forme em nós uma nova forma de viver, educar, servir e cuidar.\n\nPor isso a Igreja não é plateia. É corpo. E o corpo só amadurece quando cada parte deixa de viver para si e começa a oferecer vida ao outro.",
      question: "Sua experiência de fé tem produzido comunhão real ou apenas consumo religioso?",
      practice: "Procure alguém da comunidade e compartilhe uma parte honesta da sua caminhada, sem tentar parecer pronto.",
      reflectionPrompt: "Onde o Espírito está te chamando a sair do isolamento?"
    }),
    day({
      day: 4,
      title: "CONGREGAR É TRATAMENTO",
      verse: "Habacuque 3:2",
      verseText: "Aviva, ó Senhor, a tua obra no meio dos anos.",
      sourceFile: "devocionais/22-09.txt",
      macroTheme: "constância comunitária",
      devotional: "A vida com Deus não é feita apenas de grandes eventos espirituais. Muitas curas acontecem no tratamento contínuo: presença, Palavra, oração, mesa e repetição.\n\nCongregar não é cumprir agenda religiosa. É permanecer exposto ao cuidado de Deus por meio do corpo.\n\nQuem abandona o tratamento porque não vê resultado imediato perde o processo que formaria maturidade. A constância também é uma forma de fé.",
      question: "Você tem tratado comunhão como compromisso descartável ou como parte do cuidado de Deus?",
      practice: "Marque presença em uma conversa, culto, casa ou grupo nesta semana com intenção de ser formado, não apenas servido.",
      reflectionPrompt: "Que resistência você sente quando Deus te chama para constância comunitária?"
    }),
    day({
      day: 5,
      title: "APASCENTA OS MEUS CORDEIROS",
      verse: "João 21:15-17",
      verseText: "Apascenta os meus cordeiros.",
      sourceFile: "devocionais/19-05.txt",
      macroTheme: "amor que cuida",
      devotional: "Depois da queda de Pedro, Jesus não entrega a ele um discurso de condenação, mas uma pergunta de amor. E a resposta do amor vira cuidado: apascenta os meus cordeiros.\n\nO amor por Cristo nunca termina em emoção privada. Ele se torna responsabilidade por pessoas.\n\nA mesa de Jesus restaura quem caiu e envia quem foi restaurado para cuidar. Comunhão madura não é apenas ser acolhido; é se tornar alguém que acolhe.",
      question: "Seu amor por Jesus tem se transformado em cuidado por pessoas concretas?",
      practice: "Escolha uma pessoa e envie uma mensagem simples de cuidado, sem transformar isso em conselho pronto.",
      reflectionPrompt: "Quem Deus está colocando sob seu cuidado nesta estação?"
    })
  ],

  proposito: [
    day({
      day: 1,
      title: "QUAL É O SEU PROPÓSITO?",
      verse: "João 15:16",
      verseText: "Eu os escolhi para irem e darem fruto.",
      sourceFile: "devocionais/Devocional_07-10.txt",
      macroTheme: "propósito relacional",
      devotional: "O principal ingrediente da fé é a relação. A fé só é verdadeira quando afeta a vida do outro.\n\nFé não existe para que eu receba alguma coisa de Deus e guarde para mim. Fé existe para que, tendo recebido de Deus, eu saiba o que fazer com isso em favor do mundo.\n\nCristo não é Salvador porque faz tudo o que eu quero. Ele é Salvador porque me transforma em alguém parecido com Ele.",
      question: "Você tem buscado significado pelo que a vida pode te dar ou pelo que Deus quer oferecer através de você?",
      practice: "Pergunte em oração: quem precisa receber algo que Deus já depositou em mim?",
      reflectionPrompt: "Como sua ideia de propósito precisa deixar de ser individualista?"
    }),
    day({
      day: 2,
      title: "MINHA COMIDA É FAZER A VONTADE",
      verse: "João 4:31-34",
      verseText: "A minha comida é fazer a vontade daquele que me enviou.",
      sourceFile: "devocionais/07-04.txt",
      macroTheme: "vontade de Deus",
      devotional: "Jesus revela uma fonte de sustento que os discípulos ainda não entendiam: fazer a vontade do Pai. Há uma satisfação que não vem apenas de receber, mas de viver alinhado ao envio de Deus.\n\nMuitas vezes procuramos força em lugares que alimentam apenas desejo, ansiedade e comparação. Jesus encontra sustento na obediência.\n\nA pergunta não é apenas o que eu quero fazer da minha vida, mas que vontade está me alimentando por dentro.",
      question: "O que tem alimentado suas decisões: vontade de Deus ou necessidade de controle?",
      practice: "Antes de uma tarefa comum de hoje, ore: que isso também seja feito diante de Deus.",
      reflectionPrompt: "Onde obedecer a Deus pode se tornar alimento para sua alma?"
    }),
    day({
      day: 3,
      title: "DEUS NÃO POUPOU O TRABALHO",
      verse: "Gênesis 2:15",
      verseText: "O Senhor Deus colocou o homem no jardim do Éden para cuidar dele e cultivá-lo.",
      sourceFile: "devocionais/devocional_09-07.txt",
      macroTheme: "trabalho e vocação",
      devotional: "O trabalho não nasceu como castigo. Antes da queda, Deus já havia chamado o homem para cuidar e cultivar o jardim.\n\nIsso muda a forma como vemos vocação. Trabalho não é apenas sobrevivência, salário ou status. É participação na ordem criadora de Deus.\n\nQuando a fé alcança o trabalho, ela transforma o jeito de servir, produzir, liderar e cuidar. Não trabalhamos apenas para conquistar a vida que queremos, mas para oferecer algo que abençoe a terra.",
      question: "Seu trabalho tem sido visto apenas como meio de sustento ou também como lugar de serviço?",
      practice: "Escolha uma tarefa de hoje e faça com intenção de cuidado, não apenas de conclusão.",
      reflectionPrompt: "Como Deus pode transformar sua visão sobre trabalho e responsabilidade?"
    }),
    day({
      day: 4,
      title: "O QUE SUAS MÃOS TIVEREM QUE FAZER",
      verse: "Eclesiastes 9:10",
      verseText: "O que as suas mãos tiverem que fazer, que o façam com toda a sua força.",
      sourceFile: "devocionais/07-10.txt",
      macroTheme: "diligência e tempo",
      devotional: "Existe uma espiritualidade que foge da vida concreta e chama isso de fé. Mas a Palavra também nos chama para inteireza no que está diante das nossas mãos.\n\nFazer com toda força não é viver ansioso por performance. É entender que tempo, energia e oportunidade são dons que devem servir ao propósito.\n\nA vida passa. O que está em suas mãos hoje não deve ser desperdiçado por distração, medo ou comparação.",
      question: "O que Deus já colocou nas suas mãos e você tem adiado por medo, cansaço ou distração?",
      practice: "Escolha uma tarefa negligenciada e dê um passo concreto nela hoje.",
      reflectionPrompt: "Que responsabilidade precisa ser assumida como parte da sua adoração?"
    }),
    day({
      day: 5,
      title: "SEMEADURA",
      verse: "2 Coríntios 9:7-8",
      verseText: "Deus ama quem dá com alegria.",
      sourceFile: "devocionais/Semeadura.txt",
      macroTheme: "recursos e entrega",
      devotional: "Toda vida carrega sementes: tempo, dinheiro, energia, atenção, conhecimento, presença. A pergunta é onde estamos plantando tudo isso.\n\nMuitas pessoas correm atrás de projetos que consomem tudo e não formam nada eterno. A fé reorganiza nossos critérios de administração pessoal.\n\nSemeadura não é barganha com Deus. É consciência de que tudo o que recebi precisa encontrar uma causa maior que eu.",
      question: "Em razão de que você tem deixado sua vida ser consumida?",
      practice: "Separe um recurso concreto hoje: tempo, dinheiro ou atenção, e plante em favor de alguém ou de uma causa do Reino.",
      reflectionPrompt: "Que tipo de fruto sua semeadura atual está formando?"
    })
  ],

  "reino-publico": [
    day({
      day: 1,
      title: "A TEOLOGIA SAI DA IGREJA",
      verse: "Salmo 24:1",
      verseText: "Do Senhor é a terra e tudo o que nela existe.",
      sourceFile: "devocionais/Teologia Pública.txt",
      macroTheme: "teologia pública",
      devotional: "Teologia pública é a teologia que sai da igreja para responder às questões do mundo. Se Deus é Senhor de tudo, então a fé não pode ficar confinada ao culto.\n\nA criação, a cidade, a política, a economia, a cultura e o sofrimento humano também precisam ser pensados diante de Deus.\n\nIsso não transforma a igreja em partido nem o púlpito em palanque. Transforma discípulos em gente capaz de discernir o mundo real a partir do Reino.",
      question: "Sua fé tem respostas apenas para o domingo ou também para as questões reais da cidade?",
      practice: "Escolha uma notícia desta semana e ore tentando enxergá-la a partir da justiça, misericórdia e verdade de Deus.",
      reflectionPrompt: "Que área da vida pública você precisa voltar a pensar diante de Deus?"
    }),
    day({
      day: 2,
      title: "O MUNDO ESTÁ TE VENDO",
      verse: "Mateus 5:13-14",
      verseText: "Vocês são o sal da terra. Vocês são a luz do mundo.",
      sourceFile: "devocionais/21-07.txt",
      macroTheme: "testemunho",
      devotional: "Jesus não disse que a Igreja deveria se esconder do mundo, mas que ela é sal e luz. Isso significa presença, contraste e responsabilidade.\n\nO mundo está nos vendo: na forma como trabalhamos, debatemos, compramos, educamos, servimos e reagimos quando somos contrariados.\n\nSer luz não é fazer propaganda de si mesmo. É viver de um modo em que a vida de Deus se torne visível.",
      question: "O que sua forma de viver tem revelado sobre Deus para quem observa você de perto?",
      practice: "Escolha um ambiente onde você será observado hoje e pratique uma resposta diferente da lógica comum.",
      reflectionPrompt: "Onde seu testemunho público precisa ganhar coerência?"
    }),
    day({
      day: 3,
      title: "SABEDORIA NAS REDES",
      verse: "Oséias 4:6",
      verseText: "Meu povo foi destruído por falta de conhecimento.",
      sourceFile: "devocionais/Deus e o Facebook.txt",
      macroTheme: "entendimento e redes",
      devotional: "O mundo sofre por falta de entendimento. Não é falta de informação, porque nunca tivemos tanta. É falta de sabedoria para interpretar a vida diante de Deus.\n\nNas redes, a ausência de entendimento vira pressa, reação, vaidade e agressividade. A fé pode virar opinião religiosa sem maturidade espiritual.\n\nDeus não nos chama apenas para postar sobre Ele, mas para pensar, falar e reagir como gente formada por Ele.",
      question: "Sua presença digital revela entendimento de Deus ou apenas reação religiosa?",
      practice: "Antes de comentar, postar ou compartilhar algo hoje, pergunte se aquilo edifica, corrige com amor ou apenas alimenta ruído.",
      reflectionPrompt: "Como Deus quer formar sua fala pública?"
    }),
    day({
      day: 4,
      title: "QUANDO A POLÍTICA VIRA IDENTIDADE",
      verse: "Filipenses 3:20",
      verseText: "A nossa cidadania está nos céus.",
      sourceFile: "devocionais/13-01_2.txt",
      macroTheme: "polarização e Reino",
      devotional: "Vivemos em um tempo de divisões intensas. A política pode deixar de ser lugar de responsabilidade e se tornar identidade final.\n\nQuando isso acontece, irmãos viram inimigos e opiniões viram critérios de comunhão. O Reino de Deus corrige todas as nossas lealdades.\n\nA cidadania celestial não nos tira da responsabilidade pública. Ela impede que qualquer bandeira menor ocupe o lugar de Cristo.",
      question: "Alguma posição política tem moldado mais sua forma de tratar pessoas do que o Evangelho?",
      practice: "Ore hoje por alguém de quem você discorda, pedindo que Deus forme em você mansidão e discernimento.",
      reflectionPrompt: "Onde o Reino precisa corrigir suas lealdades públicas?"
    }),
    day({
      day: 5,
      title: "MISSÃO NO MUNDO REAL",
      verse: "João 6:30-40",
      verseText: "O pão de Deus é aquele que desceu do céu e dá vida ao mundo.",
      sourceFile: "devocionais/21-04_2 (missão).txt",
      macroTheme: "missão e presença",
      devotional: "A missão de Deus não é uma atividade isolada dentro da agenda da igreja. É o movimento do próprio Cristo dando vida ao mundo.\n\nMuitas vezes pedimos sinais, métodos e garantias. Jesus aponta para si mesmo como o pão que sustenta a vida.\n\nSer igreja em missão é repartir esse pão no mundo real: relações, trabalho, cidade, dores e perguntas concretas das pessoas.",
      question: "Onde você tem esperado um método missionário quando Deus já colocou pessoas concretas perto de você?",
      practice: "Convide alguém para ler um devocional com você nesta semana, sem pressão e sem discurso pronto.",
      reflectionPrompt: "Quem Deus está colocando no seu caminho como campo de missão?"
    })
  ],

  "casa-relacoes": [
    day({
      day: 1,
      title: "NÃO É BOM ESTAR SÓ",
      verse: "Gênesis 2:18",
      verseText: "Não é bom que o homem esteja só.",
      sourceFile: "devocionais/Casais.txt",
      macroTheme: "aliança e companhia",
      devotional: "Antes mesmo do pecado, Deus disse que não era bom que o homem estivesse só. Isso significa que relacionamento não é remendo para uma vida quebrada; é parte do desenho de Deus.\n\nMas relações maduras não existem apenas para satisfazer carências. Elas formam, confrontam, sustentam e revelam áreas onde ainda precisamos ser curados.\n\nAliança é mais profunda que conveniência. É decidir construir vida com outro diante de Deus.",
      question: "Você tem tratado relacionamentos como lugar de formação ou apenas como fonte de satisfação?",
      practice: "Faça uma pergunta honesta a alguém próximo: como posso te servir melhor nesta fase?",
      reflectionPrompt: "O que suas relações têm revelado sobre seu coração?"
    }),
    day({
      day: 2,
      title: "MINHA FAMÍLIA A PARTIR DE MIM",
      verse: "Josué 24:15",
      verseText: "Eu e a minha casa serviremos ao Senhor.",
      sourceFile: "devocionais/Minha Família Transformada a partir de mim.txt",
      macroTheme: "responsabilidade familiar",
      devotional: "É comum orarmos para Deus mudar nossa casa, nossos filhos, nosso cônjuge e nossas circunstâncias. Mas muitas vezes Deus começa a transformação em nós.\n\nFamília não muda apenas por cobrança, discurso ou controle. Muda quando alguém aceita ser formado por Deus primeiro.\n\nServir ao Senhor em casa começa quando deixamos de pedir que todos mudem a nosso favor e passamos a perguntar quem precisamos nos tornar por amor.",
      question: "Você tem pedido que Deus transforme sua família sem permitir que Ele comece por você?",
      practice: "Escolha uma atitude concreta de serviço dentro de casa e faça sem anunciar, cobrar ou esperar retorno.",
      reflectionPrompt: "Que mudança Deus está começando em você para alcançar sua casa?"
    }),
    day({
      day: 3,
      title: "RELACIONAMENTOS SEM PERFORMANCE",
      verse: "Romanos 12:10",
      verseText: "Dediquem-se uns aos outros com amor fraternal.",
      sourceFile: "devocionais/relacionamentos.txt",
      macroTheme: "vínculos e verdade",
      devotional: "Relacionamentos adoecem quando viram palco de performance. Tentamos parecer fortes, certos, espirituais e bem resolvidos, enquanto escondemos medo, orgulho e carência.\n\nO Evangelho nos chama para vínculos mais verdadeiros. Amar não é manipular o outro para atender minhas expectativas. Amar é buscar a formação do outro diante de Deus.\n\nRelações saudáveis não nascem de pessoas perfeitas, mas de pessoas dispostas a viver em verdade.",
      question: "Em qual relação você tem performado em vez de se apresentar com verdade?",
      practice: "Tenha uma conversa simples e honesta, sem acusar e sem se defender de tudo.",
      reflectionPrompt: "Onde Deus está chamando você a trocar imagem por verdade?"
    }),
    day({
      day: 4,
      title: "SEXUALIDADE NO SANTO DOS SANTOS",
      verse: "1 Coríntios 6:19",
      verseText: "O corpo de vocês é santuário do Espírito Santo.",
      sourceFile: "devocionais/Santo dos Santos - sexualidade.txt",
      macroTheme: "corpo e santidade",
      devotional: "A fé cristã não trata o corpo como inimigo. O corpo é lugar de adoração, entrega e presença do Espírito.\n\nPor isso sexualidade não pode ser reduzida a desejo, consumo ou culpa. Ela precisa ser pensada a partir de santidade, aliança e amor.\n\nSantidade não é repressão vazia. É permitir que Deus organize também os desejos, afetos e limites que carregamos no corpo.",
      question: "Sua forma de lidar com desejo tem sido governada por consumo, culpa ou presença de Deus?",
      practice: "Ore entregando a Deus seus afetos e limites, sem esconder áreas que você costuma tratar sozinho.",
      reflectionPrompt: "Como a presença do Espírito muda sua relação com o próprio corpo?"
    }),
    day({
      day: 5,
      title: "SOMOS UM",
      verse: "João 17:21",
      verseText: "Que todos sejam um.",
      sourceFile: "devocionais/somos um.txt",
      macroTheme: "unidade e testemunho",
      devotional: "A unidade não é apenas um ideal bonito. Ela é testemunho. Jesus ora para que sejamos um, para que o mundo creia.\n\nIsso significa que nossos vínculos comunicam algo sobre Deus. Quando vivemos alianças quebradas por orgulho, vaidade e disputa, o mundo aprende uma mentira sobre o Pai.\n\nUnidade não apaga diferenças. Ela submete diferenças ao amor de Cristo.",
      question: "Que ruptura, disputa ou orgulho tem enfraquecido seu testemunho de unidade?",
      practice: "Dê um passo de reconciliação: uma oração, uma mensagem, um pedido de perdão ou uma escuta sem defesa.",
      reflectionPrompt: "Onde Cristo está chamando você a proteger a unidade?"
    })
  ]
};

// CASA_30_TRAIL/CASA_30_DEVOTIONALS ficam no bundle principal (arquivo pequeno,
// ~80KB) porque sao o conteudo padrao mostrado assim que o app abre.
if (!TRAILS_DATA.some((trail) => trail.id === CASA_30_TRAIL.id)) {
  TRAILS_DATA.push(CASA_30_TRAIL);
}
DEVOTIONALS_MOCK[CASA_30_TRAIL.id] = CASA_30_DEVOTIONALS;

function normalizeDevotionalDefaults() {
  Object.entries(DEVOTIONALS_MOCK).forEach(([trailId, devotionals]) => {
    devotionals.forEach((devotional) => {
      devotional.objective = devotional.objective || devotional.macroTheme;
      devotional.flow = devotional.flow || ["Começo", "Meio", "Fim"];
    });
  });
}
normalizeDevotionalDefaults();

// --- TRILHAS CURADAS (843KB) CARREGADAS SOB DEMANDA ---
// Antes este arquivo importava CuratedTrails.generated.js direto no topo, o
// que jogava ~843KB de texto devocional dentro do bundle principal do app
// (baixado e interpretado antes mesmo da tela de login aparecer). Agora esse
// conteudo só é buscado (e vira um chunk JS separado, cacheado pelo
// service worker) quando alguém realmente precisa dele.
let curatedTrailsPromise = null;

export function ensureCuratedTrailsLoaded() {
  if (!curatedTrailsPromise) {
    curatedTrailsPromise = import(
      /* webpackChunkName: "curated-trails" */ "./CuratedTrails.generated"
    ).then(({ CURATED_MARKDOWN_TRAILS }) => {
      CURATED_MARKDOWN_TRAILS.forEach(({ devotionals, ...trail }) => {
        const existingIndex = TRAILS_DATA.findIndex((item) => item.id === trail.id);
        if (existingIndex >= 0) {
          TRAILS_DATA[existingIndex] = {
            ...TRAILS_DATA[existingIndex],
            ...trail,
            progress: TRAILS_DATA[existingIndex].progress || trail.progress || 0,
            nextDay: TRAILS_DATA[existingIndex].nextDay || trail.nextDay || "Começar"
          };
        } else {
          TRAILS_DATA.push(trail);
        }
        DEVOTIONALS_MOCK[trail.id] = devotionals;
      });
      normalizeDevotionalDefaults();
      return true;
    });
  }
  return curatedTrailsPromise;
}

export function areCuratedTrailsLoaded() {
  return curatedTrailsPromise !== null;
}
